export const truncateKey = (key) => {
    if (!key) return '';
    return key.length <= 18 ? key : `${key.slice(0, 14)}...${key.slice(-4)}`;
};
